/* eslint-disable */
require('./arrow-down')
require('./arrow-left')
require('./arrow-right')
require('./arrow-up')
require('./download')
require('./icon-facebook')
require('./icon-linkedin')
require('./icon-twitter')
require('./menu-close')
require('./menu')
require('./mobile-indicator')
require('./share')
require('./size')
require('./swipe-pointer')
require('./xAxis')
require('./yAxis')
